/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const AlertsOn = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.75 1V3.04647C14.1071 3.21586 15.324 3.83872 16.2426 4.75736C17.3276 5.84228 17.9999 7.34322 18 9L18.001 11.8068C19.8196 12.8893 21 15.0623 21 17.25V18H3V17.25C3 14.813 4.19392 12.8484 6.00004 11.8027L6 9.00001C6 7.34336 6.67239 5.84232 7.75736 4.75736C8.67599 3.83872 9.8929 3.21586 11.25 3.04647V1H12.75ZM12 4.5C10.7572 4.5 9.63318 5.00286 8.81802 5.81802C8.00286 6.63318 7.5 7.75715 7.5 8.99999L7.50005 12.729L7.07195 12.9324C5.75631 13.5576 4.77428 14.8135 4.54899 16.5H19.4403C19.1944 14.9487 18.2114 13.5427 16.929 12.9329L16.5013 12.7295L16.5 9.00051C16.5 7.75739 15.9971 6.63317 15.182 5.81802C14.3668 5.00286 13.2428 4.5 12 4.5ZM13.5 20V19.5H15V20C15 20.8282 14.6634 21.5792 14.1213 22.1213C13.5792 22.6634 12.8282 23 12 23C11.1718 23 10.4208 22.6634 9.87868 22.1213C9.33661 21.5792 9 20.8282 9 20V19.5H10.5V20C10.5 20.4144 10.6671 20.7884 10.9393 21.0607C11.2116 21.3329 11.5856 21.5 12 21.5C12.4144 21.5 12.7884 21.3329 13.0607 21.0607C13.3329 20.7884 13.5 20.4144 13.5 20Z"
                        fill={color}
                    />
                </svg>
        );
    };
